/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type StreamListItem_stream$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type StreamList_viewer$ref: FragmentReference;
export type StreamList_viewer = {|
  +streams: ?{|
    +totalCount: ?number,
    +streams: ?$ReadOnlyArray<?{|
      +$fragmentRefs: StreamListItem_stream$ref
    |}>,
  |},
  +$refType: StreamList_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "StreamList_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "page",
      "type": "Int!",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "search",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "states",
      "type": "[String]",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "streams",
      "name": "streamsPaginate",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page",
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "pageSize",
          "value": 10,
          "type": "Int"
        },
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "search",
          "type": "String"
        },
        {
          "kind": "Variable",
          "name": "states",
          "variableName": "states",
          "type": "[String]"
        }
      ],
      "concreteType": "StreamsPagination",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "totalCount",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "streams",
          "storageKey": null,
          "args": null,
          "concreteType": "Stream",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "StreamListItem_stream",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '478650a6034731b763bab6b57b7c452d';
module.exports = node;



// WEBPACK FOOTER //
// src/components/streams/__generated__/StreamList_viewer.graphql.js